<template>
 <b-container>
     <b-form-group horizontal label="Filter" class="text-left mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
    </b-form-group>
    <br>
     <!--<a href="#" v-scroll-to="'#element'">Scroll to #element</a>-->
     <b-row>
     
      <b-col md="6" class="my-1">
        <b> Total Hours</b> : {{totalHours}}
      </b-col>
      <b-col md="6" class="my-1">
        <b> Total Mileage</b> : {{totalMilage}}
      </b-col>
    </b-row>
    <br>
  <b-table striped hover bordered   :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage" :filter="filter" @filtered="onFiltered" primary-key="idTicketTag">

   
    <template slot="ActualDate" slot-scope="row">
         {{row.item.ActualDate | formatDate  }}
    </template>     
    <template slot="show_details" slot-scope="row">
      <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
      <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2">
       {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
      </b-button>
      <!-- In some circumstances you may need to use @click.native.stop instead -->
      <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
      
    </template>
    <template slot="ticketlink" slot-scope="row">
        <a href="#" @click="clickedTicket(row.item.idTicket,row.item.idTicketComment)" v-scroll-to="'#element'" title="Click to add tag using this ticket">{{ row.item.idTicket}} </a>
    </template>

    <template v-if="admin" slot="admin" slot-scope="row">
         <b-button v-if="!row.item.locked" @click="lockTag(row.index)">
             Lock Ticket
         </b-button>
         <span v-if="row.item.locked">Locked</span>
    </template>    
    <template slot="row-details" slot-scope="row">
      <b-card>
        <b-row class="mb-2 " v-if="row.item.locked">
         
          <b-col class="text-left"><b style="background-color:red;color:white">Tag is Locked and cannot be edited.</b></b-col>
        </b-row>  
        <b-row class="mb-2 ">
          <b-col sm="3" class="text-left"><b>Ticket ID:</b></b-col>
          <b-col><a href="#" @click="clickedTicket(row.item.idTicket,row.item.idTicketComment)" v-scroll-to="'#element'" title="Click to add tag using this ticket">{{ row.item.idTicket }}</a></b-col>
        </b-row>
        <b-row class="mb-2 ">
          <b-col sm="3" class="text-left"><b>idTag:</b></b-col>
          <b-col>{{ row.item.idTicketTag }}</b-col>
        </b-row>
        <b-row class="mb-2 ">
          <b-col sm="3" class="text-left"><b>SiteName:</b></b-col>
          <b-col>{{ row.item.SiteName }}</b-col>
        </b-row>
        <b-row class="mb-2 ">
          <b-col sm="3" class="text-left"><b>Comment:</b></b-col>
          <b-col>{{ row.item.Comment }}</b-col>
        </b-row>
        <b-row class="mb-2 ">
          <b-col sm="3" class="text-left"><b>Date:</b></b-col>
          <b-col><datetime v-model="row.item.ActualDate" type="date" format="yyyy-MM-dd" style="border-radius: 4px;" zone='local' value-zone='local'></datetime></b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-left"><b>TagCategory:</b></b-col>
          <b-col v-if="!row.item.locked">
              <select class="form-control"  v-model="row.item.TagCategory" style="overflow:scroll;" >
                    <option value="PROJECT">PROJECT ( S1 -> C4 )</option>
                    <option value="MAINTENANCE & OPERATIONS">MAINTENANCE ( After C4 )</option>
                    <option value="GENERAL">GENERAL</option>
                </select><!--{{ row.item.TagCategory }}-->
          </b-col>
            <b-col v-if="row.item.locked">
              {{ row.item.TagCategory }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-left"><b>TagSubCategory:</b></b-col>
          <b-col v-if="!row.item.locked">
              <select class="form-control"  v-model="row.item.TagSubCategory" style="overflow:scroll;" >
                    <option value="HOURS">HOURS</option>
                    <option value="MILEAGE">MILEAGE</option>
                 
                </select><!-- {{ row.item.TagSubCategory }} -->
             </b-col>
            <b-col v-if="row.item.locked">
             {{ row.item.TagSubCategory }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-left"><b>Value:</b></b-col>
            <b-col v-if="!row.item.locked">
              <b-form-input v-model="row.item.valueAny" type="number"/>
            </b-col>
            <b-col v-if="row.item.locked">
             {{ row.item.valueAny }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-left"><b>TicketDescription:</b></b-col>
          <b-col>{{ row.item.TicketDescription }}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-left"><b>CreatedBy:</b></b-col>
          <b-col>{{ row.item.CreatedBy }}</b-col>
        </b-row>
        <b-button size="sm" @click="row.toggleDetails" style="margin:4px">Hide Details</b-button >
        <b-button v-if="!row.item.locked" size="sm" @click="askUpdateItem(row.item,row.item.idTicketTag,row)" style="margin:4px">Update Tag</b-button>
        <b-button v-if="!row.item.locked" size="sm" @click="askDeleteItem(row.item,row.item.idTicketTag)" style="margin:4px">Delete Tag</b-button>
      </b-card>
    </template>
  </b-table>
  <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
      <b-col md="3" class="my-1">
        <b> Total Hours</b> : {{totalHours}}
      </b-col>
      <b-col md="3" class="my-1">
        <b> Total Mileage</b> : {{totalMilage}}
      </b-col>
    </b-row>
     </b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import EventBus from '../eventBus';

export default {
  props : ['idemployee','nrdays','admin'], 
  data () {
    return {
      fields: [
          {
            key: 'ActualDate',
            label : 'Date',
            sortable: true
          },
          /*{
            key: 'idTicket',
            label : 'Ticket #'
          },*/
          {
            key: 'ticketlink',
            label : 'Ticket #',
            sortable: false
          },
          {
            key: 'SiteName',
            label : 'Site',
            sortable: false
          },
          {
            key: 'Comment',
            label : 'TimeSheet Comment',
            sortable: false
          },
          {
            key: 'TagCategory',
            label : 'Work type',
            sortable: false
          },
          {
            key: 'TagSubCategory',
            label : 'Type',
            sortable: false
          },
          {
            key: 'valueAny',
            label : 'Value',
            sortable: false
          },
          {
            key: 'show_details',
            label : '',
            sortable: false
          }
          ]
          
          
        ,
      items: [
        
      ],
      
      totalRows : 0,
      filteredItems : null,
      currentPage : 1,
      perPage : 10,
      filter: "",
      totalHours : 0,
      totalMilage : 0


    }
  },
  methods : {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.filteredItems = filteredItems;
      this.currentPage = 1;
      let hoursCount = 0;
      let milageCount = 0;
      for( var i = 0 ; i < filteredItems.length ; i++ )
      {
          if (filteredItems[i].TagSubCategory == 'HOURS' )
          {
              hoursCount+=parseFloat(filteredItems[i].valueAny);
          }
          if (filteredItems[i].TagSubCategory == 'MILEAGE' )
          {
              milageCount+=parseFloat(filteredItems[i].valueAny);
          }
          this.totalHours = hoursCount;
          this.totalMilage = milageCount;
      }
      if (filteredItems.length == 0 )
      {
          this.totalHours = 0;
          this.totalMilage = 0;

      }
    },
    askUpdateItem(item, idTicketTag,row){
        console.log("Ask to update item :"+item);
        
        console.log("Row looks like ");
        console.log(row);
        console.log("With Tag ID #"+item.idTicketTag+" will be updated");
        let mainObject = this;
        let newHTMl = 'New Date : '+moment(item.ActualDate).format('YYYY-MM-DD')+'<br>'+
                        'New TagCategory : '+item.TagCategory+'<br>'+
                      'New TagSubCategory : '+ item.TagSubCategory  +'<br>'+
                      'New Value : '+ item.valueAny;
        let text = 'Are you sure you want to update Ticket Tag #'+idTicketTag+ ' ?'
        console.log(mainObject);
        mainObject.$swal({
        title: text,
        type: 'warning',
        html: newHTMl,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
            'Update Ticket Tag',
        confirmButtonAriaLabel: 'Ok',
        cancelButtonText:
            'Cancel',
        cancelButtonAriaLabel: 'Cancel',
        }).then((result) => {
            if (result.value)
            {
                var TicketTagCategory = 1;
                var TicketTagSubCategory = 1;

                console.log("Call updateTicket")
                switch(item.TagCategory )
                {
                    case "PROJECT" : if ( item.TagSubCategory == "HOURS" )
                                    {
                                        TicketTagCategory = 1;
                                        TicketTagSubCategory = 1; 
                                    }
                                    else
                                    {
                                        TicketTagCategory = 1;
                                        TicketTagSubCategory = 2; 
                                    }
                                break;
                    case "MAINTENANCE & OPERATIONS" : if ( item.TagSubCategory == "HOURS" )
                                    {
                                        TicketTagCategory = 5;
                                        TicketTagSubCategory = 7; 
                                    }
                                    else
                                    {
                                        TicketTagCategory = 5;
                                        TicketTagSubCategory = 8; 
                                    }
                                break;
                    case "GENERAL" : if ( item.TagSubCategory == "HOURS" )
                                    {
                                        TicketTagCategory = 6;
                                        TicketTagSubCategory = 10; 
                                    }
                                    else
                                    {
                                        TicketTagCategory = 6;
                                        TicketTagSubCategory = 11; 
                                    }
                                break;            
                    


                }
                let newDate = moment(item.ActualDate).format('YYYY-MM-DD')
                axios.get(localStorage.getItem('ticketCopURL') +'/updateTicketTag', {
                    params: {
                        idTicketTag : idTicketTag,
                        TicketTagCategory : TicketTagCategory,
                        TicketTagSubCategory : TicketTagSubCategory,
                        value : item.valueAny,
                        date :  newDate


                    
                    },
                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                    console.log(response);
                    if ( response.data != "error" )
                    {
                        console.log("tag was updated");
                        mainObject.showAlert("Tag was updated.",500,false,"info",false)
                        EventBus.$emit('RELOAD_SUMMARY_TABLE', "None");
                        //mainObject.filteredItems.splice(index, 1);
                    }
                    else
                    {
                        console.log("Could not lock ticket");
                         mainObject.showAlert("Could not update Tag.",1500,false,"error",false)
                    }
                    

                    })
                    .catch(function (error) {
                        console.log(error);
                        mainObject.showAlert("Could not update Tag.",1500,false,"error",false)
                    })
                    .then(function () {
                    // always executed
                    //console.log("Made request axios ticket to get sites");
                    
                }); // end of axios call
            }
        
        });
    },
    askDeleteItem(item,idTagToDelete){
        console.log("Ask to update item :"+item);
       
        console.log("With Tag ID #"+idTagToDelete+" will be deleted");
        let mainObject = this;
        var text = 'Are you sure you want to delete Ticket Tag #'+idTagToDelete+' ?';
        console.log(mainObject);
        mainObject.$swal({
        title: text,
        type: 'warning',
        html: 'This cannot be undone.',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
            'Delete Ticket Tag',
        confirmButtonAriaLabel: 'Ok',
        cancelButtonText:
            'Cancel',
        cancelButtonAriaLabel: 'Cancel',
        }).then((result) => {
            if (result.value)
            {
                console.log("Call lockTicketTag")
                axios.get(localStorage.getItem('ticketCopURL') +'/deleteTicketTag', {
                    params: {
                        idTicketTag : idTagToDelete,
                    
                    },
                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                    console.log(response);
                    if ( response.data != "error" )
                    {
                        console.log("tag was deleted");
                        // TO DO Fix the list - fin item using idtag and then splice
                        let index = mainObject.filteredItems.findIndex(item => item.idTicketTag === idTagToDelete);
                        console.log("index to delete :"+index);
                        
                        mainObject.filteredItems.splice(index, 1);
                        EventBus.$emit('RELOAD_SUMMARY_TABLE', "None");
                    }
                    else
                    {
                        console.log("Could not lock ticket");
                    }
                    

                    })
                    .catch(function (error) {
                    console.log(error);
                    })
                    .then(function () {
                    // always executed
                    //console.log("Made request axios ticket to get sites");
                    
                }); // end of axios call
            }
        
        });
    },
    clickedTicket(idTicket,idComment)
    {

       
        //console.log(this.$parent);
         const payload = {
        idTicket: idTicket,
        idComment: idComment
        }
         console.log("payload");
           console.log(payload);
        EventBus.$emit('CLICKED_TICKET', payload);
        //this.$parent.$parent.getTicket(idTicket);
    },
    lockTag(item)
    {
        console.log("Ask to lock item :"+item);
        
        console.log("With Tag ID #"+item.idTicketTag+" will be locked");
        let mainObject = this;
                console.log(mainObject);
                mainObject.$swal({
                title: 'Are you sure you want to lock Ticket ?',
                type: 'info',
                html: 'This cannot be undone.',
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'Lock Ticket Tag',
                confirmButtonAriaLabel: 'Ok',
                cancelButtonText:
                    'Cancel',
                cancelButtonAriaLabel: 'Cancel',
                }).then((result) => {
                    if (result.value)
                    {
                        console.log("Call lockTicketTag")
                        axios.get(localStorage.getItem('ticketCopURL') +'/lockTicketTag', {
                            params: {
                                idTicketTag : item.idTicketTag,
                               
                            },
                            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                            })
                            .then(function (response) {
                            console.log(response);
                            if ( response.data != "error" )
                            {
                                console.log("tag was locked");
                                item.locked = true;
                            }
                            else
                            {
                                console.log("Could not lock ticket");
                            }
                            

                            })
                            .catch(function (error) {
                            console.log(error);
                            })
                            .then(function () {
                            // always executed
                            //console.log("Made request axios ticket to get sites");
                            
                        }); // end of axios call
                    }
                   
                });

        

    },
    showAlert : function (msg,delay,gotoprevPage,type,reloadPage)
        {
            let timerInterval;
            let mainObject = this;
            mainObject.$swal({
            //title: 'Auto close alert!',
            html: msg,
            type: type,
            timer: delay,
            onBeforeOpen: () => {
                mainObject.$swal.showLoading()
                timerInterval = setInterval(() => {
                mainObject.$swal.getContent().querySelector('strong')
                    
                }, 100)
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            if (
                // Read more about handling dismissals
                result.dismiss === mainObject.$swal.DismissReason.timer
            ) {
                if ( gotoprevPage )
                mainObject.$router.go(-1);
                if (reloadPage)
                 mainObject.$router.go(0);
            }
            })  
        }
  },
  filters: {
    formatDate: function (date) {
        if (!date) return ''
        
        return moment(date).format('YYYY-MM-DD')
    }
    },
  watch : {
      idemployee : function()
      {
          console.log("Idemployee changed");
          let sinceDate = moment().subtract(self.nrdays,'days').format('YYYY-MM-DD');
      axios.get(localStorage.getItem('ticketCopURL') +'/getTagsEmployee', {
          params: {
              idEmployee : self.idemployee,
              sinceDate : sinceDate
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response);
          if ( response.data != "error" )
          {
              response.data.forEach(element => {
                   element.ActualDate = moment(element.ActualDate).format('YYYY-MM-DD');
              });  
            
                 
             
              self.items = response.data;
          }
          //mainObject.sites = response.data;
          //response.data.forEach(el => {
          //     mainObject.timeSlots.push({ Date : el.ActualDate , TicketDescription : el.TicketDescription, TagCategory : el.TagCategory,TagSubCategory : el.TagSubCategory,Value : el.valueAny });
          //});
         
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket to get sites");
         
        }); // end of axios call
      }
  },
  created : function()
  {
      let self = this;
      if ( self.admin )
      {
          self.fields.push({key: 'admin',
            label : '',
            sortable: false})
      }
      console.log("Creating table with ");
      console.log(self);
      let sinceDate = moment().subtract(self.nrdays,'days').format('YYYY-MM-DD');
      axios.get(localStorage.getItem('ticketCopURL') +'/getTagsEmployee', {
          params: {
              idEmployee : self.idemployee,
              sinceDate : sinceDate
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response);
          if ( response.data != "error" )
          {
            response.data.forEach(element => {
                element.ActualDate = moment(element.ActualDate).format('YYYY-MM-DD');
            });  
            
                 
             
            self.items = response.data;
            self.filteredItems = self.items;
            self.onFiltered(self.filteredItems);
            let hoursCount = 0;
            let milageCount = 0;
            self.totalHours = 0;
            self.totalMilage = 0;
            for( var i = 0 ; i < self.items.length ; i++ )
            {
                if (self.items[i].TagSubCategory == 'HOURS' )
                {
                    hoursCount+=parseFloat(self.items[i].valueAny);
                }
                if (self.items[i].TagSubCategory == 'MILEAGE' )
                {
                    milageCount+=parseFloat(self.items[i].valueAny);
                }
                self.totalHours = hoursCount;
                self.totalMilage = milageCount;
            }
            
          }
          //mainObject.sites = response.data;
          //response.data.forEach(el => {
          //     mainObject.timeSlots.push({ Date : el.ActualDate , TicketDescription : el.TicketDescription, TagCategory : el.TagCategory,TagSubCategory : el.TagSubCategory,Value : el.valueAny });
          //});
         
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket to get sites");
         
        }); // end of axios call
  } // end of created
}
</script>

<!-- table-details.vue -->